export const popupStyle = {
  padding: '10px',
  transform: 'translatey(1.5rem)',
  opacity: '0.95',
  background: 'steelblue',
  maxWidth: '50%,',
};


// WEBPACK FOOTER //
// ./src/components/whoa/Tangent/styles.js